import { APP_ENABLE, APP_DISABLE } from './types'

export const appEnable = _ => ({
  type: APP_ENABLE
})

export const appDisable = () => ({
  type: APP_DISABLE
})
